import ModalThankYou from './ModalThankYou';
export default ModalThankYou;
